module.exports = {
	"id": "UY",
	"name": "Uruguay",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": 0.006698,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.020094,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.03349,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.020094,
			"23": null,
			"24": null,
			"25": 0.013396,
			"26": 0.026792,
			"27": 0.03349,
			"28": null,
			"29": 0.013396,
			"30": null,
			"31": 0.020094,
			"32": 0.013396,
			"33": 0.006698,
			"34": 0.040188,
			"35": 0.040188,
			"36": 0.03349,
			"37": 0.040188,
			"38": 0.046886,
			"39": 0.120564,
			"40": 0.040188,
			"41": 0.026792,
			"42": 0.053584,
			"43": 0.154054,
			"44": 0.073678,
			"45": 0.053584,
			"46": 1.453466,
			"47": 0.113866,
			"48": 2.250528,
			"49": 3.134664,
			"50": 0.328202,
			"51": 0.50235,
			"52": 0.495652,
			"53": 28.372728,
			"54": 8.292124,
			"55": 0.06698,
			"56": 0.046886,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.03349,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.03349,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.03349,
			"17": 0.154054,
			"18": null,
			"19": 0.006698,
			"20": 0.053584,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": 0.683196,
			"26": 0.006698,
			"27": 0.30141,
			"28": 0.026792,
			"29": 0.013396,
			"30": 0.013396,
			"31": 0.013396,
			"32": 0.013396,
			"33": 0.877438,
			"34": 0.013396,
			"35": 0.087074,
			"36": 0.013396,
			"37": 0.03349,
			"38": 0.241128,
			"39": 0.046886,
			"40": 0.06698,
			"41": 0.093772,
			"42": 0.046886,
			"43": 0.375088,
			"44": 0.046886,
			"45": 0.214336,
			"46": 0.113866,
			"47": 0.428672,
			"48": 0.341598,
			"49": 5.251232,
			"50": 0.03349,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.087074
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.006698,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.040188,
			"37": 0.06698,
			"38": 0.040188,
			"39": 0.013396,
			"40": 0.36839,
			"41": 0.080376,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.026792
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.006698,
			"6": null,
			"7": 0.013396,
			"8": 0.087074,
			"9": 0.073678,
			"10": 0.555934,
			"3.1": null,
			"3.2": null,
			"5.1": 0.013396,
			"6.1": 0.026792,
			"7.1": null,
			"9.1": 0.341598
		},
		"ios_saf": {
			"8": 0,
			"10": 1.93837963281,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0522370881557,
			"8.1-8.4": 0.0965058069317,
			"9.0-9.2": 0.0460394675271,
			"9.3": 0.70239700458
		},
		"android": {
			"3": 0,
			"4": 0.0400043669251,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00500054586563,
			"4.1": 0.144301466408,
			"4.2-4.3": 0.360753666021,
			"4.4": 0.827233158915,
			"4.4.3-4.4.4": 0.834376795866
		},
		"ie": {
			"6": null,
			"7": 0.013832826087,
			"8": 0.283572934783,
			"9": 0.1590775,
			"10": 0.145244673913,
			"11": 1.30720206522,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0648790221963,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00180219506101
		},
		"edge": {
			"12": 0.053584,
			"13": 0.241128,
			"14": 0.495652
		},
		"ie_mob": {
			"10": 0.466045408451,
			"11": 1.89747059155
		},
		"bb": {
			"7": 0.01898075,
			"10": null
		},
		"samsung": {
			"0": 2.010309
		},
		"and_uc": {
			"0": 0.161749
		},
		"op_mini": {
			"0": 0.874103782743
		},
		"and_chr": {
			"0": 26.413227
		},
		"and_ff": {
			"0": 0.075923
		}
	},
	"total": 97.28022875
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/UY.json
 ** module id = 673
 ** module chunks = 0
 **/